module.exports = __webpack_public_path__ + "img/qrcode.d053c789.svg";